import { render, staticRenderFns } from "./PersonalProfesionalizacion.vue?vue&type=template&id=4c15eb7f&scoped=true"
import script from "./PersonalProfesionalizacion.vue?vue&type=script&lang=js"
export * from "./PersonalProfesionalizacion.vue?vue&type=script&lang=js"
import style0 from "./PersonalProfesionalizacion.vue?vue&type=style&index=0&id=4c15eb7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c15eb7f",
  null
  
)

export default component.exports